import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Phone } from 'lucide-react';
type Testimonial = {
  avatarLetter: string;
  message: string;
  time: string;
  name: string;
  planBadge: string;
};
const testimonials: Testimonial[] = [{
  avatarLetter: 'M',
  message: 'Annysol acabo de recibir los documentos de mi LLC 🙌 no puedo creer lo rápido que fue todo. Gracias por explicarme cada paso, de verdad no esperaba que fuera tan sencillo 😭✨',
  time: '9:47 AM',
  name: 'María G. 🇨🇴',
  planBadge: 'Plan 1'
}, {
  avatarLetter: 'C',
  message: 'Llevo meses queriendo hacer esto y siempre lo dejaba para después porque me parecía muy complicado. Con Inkova lo hice en una semana. Ya tengo mi empresa y mi página lista para recibir clientes 🔥',
  time: '2:13 PM',
  name: 'Carlos M. 🇲🇽',
  planBadge: 'Plan 3'
}, {
  avatarLetter: 'D',
  message: 'Gracias!! La landing quedó exactamente como yo la tenía en mi cabeza pero mejor 😂 ya la compartí y varios me escribieron preguntando por mis servicios.',
  time: '11:28 AM',
  name: 'Daniela R. 🇻🇪',
  planBadge: 'Plan 2'
}, {
  avatarLetter: 'P',
  message: 'Oye de verdad gracias por tu paciencia. Tenía mil preguntas y tú siempre respondiste todo sin hacerme sentir perdida. Ya me siento con más confianza para vender 💜',
  time: '4:52 PM',
  name: 'Patricia L. 🇵🇪',
  planBadge: 'Plan 3'
}];
const INKOVA_LOGO = 'https://cdn.magicpatterns.com/uploads/5dNkMTdHn2db35CcBKtHQx/INK_2.png';
function TestimonialCard({
  t,
  i
}: {
  t: Testimonial;
  i: number;
}) {
  const [logoError, setLogoError] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    delay: i * 0.08
  }} className="overflow-hidden testimonial-card" style={{
    background: '#FFFFFF',
    border: '1px solid rgba(90,69,121,0.1)',
    borderRadius: '16px',
    boxShadow: '0 4px 20px rgba(90,69,121,0.08)',
    transition: 'transform 0.2s ease'
  }} onMouseEnter={e => {
    ;
    (e.currentTarget as HTMLDivElement).style.transform = 'translateY(-4px)';
  }} onMouseLeave={e => {
    ;
    (e.currentTarget as HTMLDivElement).style.transform = 'translateY(0)';
  }} data-id="element-538">
      {/* Header */}
      <div className="flex items-center wa-header" style={{
      background: '#f0f2f5',
      padding: '10px 14px',
      gap: '10px'
    }} data-id="element-539">
        {!logoError ? <img src={INKOVA_LOGO} alt="Inkova Creation" onError={() => setLogoError(true)} style={{
        width: '38px',
        height: '38px',
        borderRadius: '50%',
        objectFit: 'cover',
        background: '#5a4579',
        flexShrink: 0
      }} data-id="element-540" /> : <div className="flex items-center justify-center flex-shrink-0" style={{
        width: '38px',
        height: '38px',
        borderRadius: '50%',
        background: 'linear-gradient(135deg, #5a4579, #8B6BA8)',
        color: '#FFFFFF',
        fontSize: '13px',
        fontWeight: 700
      }} data-id="element-541">
            ik.
          </div>}
        <div className="flex-grow leading-tight" data-id="element-542">
          <div style={{
          color: '#111B21',
          fontSize: '14px',
          fontWeight: 600
        }} data-id="element-543">
            Inkova Creation
          </div>
          <div style={{
          color: '#25D366',
          fontSize: '12px'
        }} data-id="element-544">
            En línea
          </div>
        </div>
        <Phone style={{
        color: '#5a4579'
      }} size={18} strokeWidth={1.5} data-id="element-545" />
      </div>

      {/* Chat area */}
      <div className="wa-chat" style={{
      background: '#f0f2f5',
      padding: '12px 10px'
    }} data-id="element-546">
        <div className="relative inline-block" style={{
        background: '#FFFFFF',
        borderRadius: '4px 16px 16px 16px',
        padding: '10px 14px',
        maxWidth: '88%',
        boxShadow: '0 1px 4px rgba(0,0,0,0.08)'
      }} data-id="element-547">
          <p className="wa-msg-text" style={{
          color: '#111B21',
          fontSize: '13px',
          lineHeight: 1.5,
          margin: 0
        }} data-id="element-548">
            {t.message}
          </p>
          <div className="flex justify-end items-center" style={{
          gap: '4px',
          marginTop: '6px'
        }} data-id="element-549">
            <span style={{
            color: '#8696A0',
            fontSize: '11px'
          }} data-id="element-550">
              {t.time}
            </span>
            <span style={{
            color: '#5a4579',
            fontSize: '12px',
            letterSpacing: '-2px'
          }} aria-label="Visto" data-id="element-551">
              ✓✓
            </span>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="flex items-center wa-footer" style={{
      background: '#FFFFFF',
      padding: '8px 14px',
      borderTop: '1px solid #f0f2f5',
      gap: '10px'
    }} data-id="element-552">
        <div className="flex items-center justify-center flex-shrink-0" style={{
        width: '28px',
        height: '28px',
        borderRadius: '50%',
        background: 'linear-gradient(135deg, #5a4579, #8B6BA8)',
        color: '#FFFFFF',
        fontSize: '11px',
        fontWeight: 700,
        lineHeight: '28px',
        textAlign: 'center'
      }} data-id="element-553">
          {t.avatarLetter}
        </div>
        <div className="leading-tight" data-id="element-554">
          <div style={{
          color: '#111B21',
          fontSize: '13px',
          fontWeight: 600
        }} data-id="element-555">
            {t.name}
          </div>
          <div style={{
          color: '#8696A0',
          fontSize: '11px'
        }} data-id="element-556">
            Cliente verificado
          </div>
        </div>
        <span className="ml-auto" style={{
        background: 'rgba(90,69,121,0.08)',
        border: '1px solid rgba(90,69,121,0.2)',
        color: '#5a4579',
        fontSize: '10px',
        fontWeight: 700,
        padding: '3px 10px',
        borderRadius: '20px'
      }} data-id="element-557">
          {t.planBadge}
        </span>
      </div>
    </motion.div>;
}
export function WhatsAppTestimonialsSection() {
  const [expanded, setExpanded] = useState(false);
  return <section className="wa-section" style={{
    background: '#f8f4ff',
    padding: '60px 20px'
  }} data-id="element-558">
      {/* Responsive overrides */}
      <style data-id="element-559">{`
        @media (min-width: 769px) {
          .wa-section { padding: 80px 40px !important; }
          .wa-header { padding: 12px 16px !important; }
          .wa-chat { padding: 16px 12px !important; }
          .wa-footer { padding: 10px 16px !important; }
          .wa-msg-text { font-size: 14px !important; }
        }
      `}</style>

      <div className="max-w-6xl mx-auto" data-id="element-560">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14" data-id="element-561">
          <motion.p initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} style={{
          color: '#5a4579',
          fontSize: '11px',
          fontWeight: 700,
          letterSpacing: '2px',
          textTransform: 'uppercase',
          textAlign: 'center'
        }} data-id="element-562">
            Testimonios reales
          </motion.p>
          <motion.h2 initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.05
        }} className="text-[24px] md:text-[36px]" style={{
          color: '#2D1B4E',
          fontWeight: 800,
          textAlign: 'center',
          marginTop: '8px',
          lineHeight: 1.2
        }} data-id="element-563">
            Lo que dicen quienes ya dieron el paso
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-[14px] md:text-[16px]" style={{
          color: '#6B7280',
          textAlign: 'center',
          maxWidth: '500px',
          margin: '12px auto 0',
          lineHeight: 1.6
        }} data-id="element-564">
            Mensajes reales de emprendedores latinos que trabajaron con Inkova
          </motion.p>
        </div>

        {/* Mobile: 2 cards by default, all when expanded */}
        <div className="flex flex-col gap-3 md:hidden mx-auto" style={{
        maxWidth: '480px'
      }} data-id="element-565">
          {testimonials.slice(0, expanded ? testimonials.length : 2).map((t, i) => <TestimonialCard key={i} t={t} i={i} data-id="element-566" />)}

          {!expanded && <button onClick={() => setExpanded(true)} style={{
          background: 'transparent',
          border: '1.5px solid #5a4579',
          color: '#5a4579',
          borderRadius: '50px',
          padding: '10px 28px',
          fontSize: '14px',
          fontWeight: 600,
          display: 'block',
          margin: '16px auto 0',
          width: 'fit-content',
          cursor: 'pointer'
        }} data-id="element-567">
              Ver más testimonios
            </button>}
        </div>

        {/* Desktop: all 4 cards, 2 columns */}
        <div className="hidden md:grid md:grid-cols-2 gap-5 mx-auto" style={{
        maxWidth: '880px'
      }} data-id="element-568">
          {testimonials.map((t, i) => <TestimonialCard key={i} t={t} i={i} data-id="element-569" />)}
        </div>
      </div>
    </section>;
}